export default __webpack_public_path__ + "static/media/Ellipse 7.38bf2199.png";